import { useRouter } from 'next/router';

import { PageConfig } from '@/common/routes/RouteBuilder';
import { elysiumLogger } from '@/common/utils/sharedUtils';
import { Page404Config } from '@/modules/404Page/404PageConfig';
import { AboutContactPageConfig } from '@/modules/AboutContactPage/AboutContactPageConfig';
import { AccessoriesPageConfig } from '@/modules/Accessories/AccessoriesPageConfig';
import { BrowseBrandsConfig } from '@/modules/BrowseBrands/BrowseBrandsConfig';
import { BrowseCategoriesPageConfig } from '@/modules/BrowseCategoriesPage/BrowseCategoriesPageConfig';
import { BrowseCollectionsPageConfig } from '@/modules/BrowseCollectionsPage/BrowseCollectionsPageConfig';
import { FollowingPageConfig } from '@/modules/Following/FollowingPageConfig';
import { HomepageConfig } from '@/modules/HomePage/HomePageConfig';
import { AllLuminosPageConfig } from '@/modules/Lumino/AllLuminosPage/AllLuminosPageConfig';
import { LuminoPageConfig } from '@/modules/Lumino/LuminoPage/LuminoPageConfig';
import { ProductPageConfig } from '@/modules/ProductPage/ProductPageConfig';
import { SearchPageConfig } from '@/modules/SearchPage/SearchPageConfig';
import { WishlistPageConfig } from '@/modules/WishlistPage/WishlistPageConfig';

const UnknownPage: PageConfig = {
  readableName: 'Unknown Page',
  analyticsGaName: 'unknown',
  analyticsAthenaName: 'unknown',
  pagePathnames: [],
  displayPromoBar: false,
  defaultMeta: {
    title: 'Unknown Page',
    description: '',
    coverImage: '',
  },
};

const ElysiumKnownPages: PageConfig[] = [
  ProductPageConfig,
  HomepageConfig,
  AllLuminosPageConfig,
  LuminoPageConfig,
  FollowingPageConfig,
  BrowseCollectionsPageConfig,
  BrowseCategoriesPageConfig,
  AccessoriesPageConfig,
  WishlistPageConfig,
  BrowseBrandsConfig,
  Page404Config,
  AboutContactPageConfig,
  SearchPageConfig,
];

/**
 * Looks up the current page config based on the current URL.
 * REMEMBER: This only works on pages added to ElysiumKnownPages array.
 * @returns Current page config
 */
export const useCurrentPage = (): PageConfig => {
  const currentPath = useRouter().pathname;
  return findPageByPathname(currentPath);
};

export const findPageByPathname = (pathname: string): PageConfig => {
  const currentPage = ElysiumKnownPages.find((page) => {
    return page.pagePathnames.includes(pathname);
  });

  if (currentPage) {
    return currentPage;
  } else {
    elysiumLogger().error(`Unknown page: ${pathname}`);
    return UnknownPage;
  }
};
